import { render, staticRenderFns } from "./bnvautocomplete.vue?vue&type=template&id=5568a9ac&"
import script from "./bnvautocomplete.vue?vue&type=script&lang=js&"
export * from "./bnvautocomplete.vue?vue&type=script&lang=js&"
import style0 from "./bnvautocomplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports